import { Pipe, PipeTransform } from '@angular/core';

/**
 * Highlight any occurrence of a string that exists in the piped input with `<b>` tags.
 * @param text The string to search for substrings in.
 * @param search The string to match for inside the larger text.
 */
@Pipe({
    name: 'ofiHighlight',
    standalone: false
})
export class FoundationHighlightPipe implements PipeTransform {
    // TODO: Add class to highlighted item. That may require DomSanitizer bypassSecurity, but we don't want to allow user content (autocomplete)
    transform (text: string, search: string): string {
        if (text) {
            const re = new RegExp(search, 'gi');
            const match = text.match(re);
            if (!match) {
                return text;
            } // no match
            return text
                .replace(re, (match) => `<b>${match}</b>`) // Embiggen match.
                .replace(/\s/g, '&nbsp;'); // Replace space characters so they aren't collapsed by innerHtml.
        }
        return text;
    }
}
